import React from "react";
import { motion } from "framer-motion";
import { ArrowRight, MessageCircle } from "lucide-react";

const CallToActionBanner = () => {
    return (
        <section className="relative w-full py-24 px-4 sm:px-6 lg:px-8 bg-yellow-400 overflow-hidden border-t-4 border-red-700">
            {/* Subtle, Professional Dark Grid Pattern for Yellow BG */}
            <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGNpcmNsZSBjeD0iMSIgY3k9IjEiIHI9IjEiIGZpbGw9InJnYmEoMCwgMCwgMCwgMC4wNSkiLz48L3N2Zz4=')] pointer-events-none"></div>

            <div className="relative z-10 max-w-4xl mx-auto text-center">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-100px" }}
                    transition={{ duration: 0.5, ease: "easeOut" }}
                >
                    {/* Headline */}
                    <h2 className="text-4xl md:text-5xl lg:text-6xl font-black text-neutral-900 mb-6 leading-tight">
                        Your Preparation Starts{" "}
                        <span className="text-red-700">Here.</span>
                    </h2>

                    {/* Subheadline */}
                    <p className="text-lg md:text-xl text-neutral-800 mb-10 max-w-2xl mx-auto leading-relaxed font-bold">
                        Take the absolute first step towards your dream. Secure
                        personalized mentorship, structured guidance, and a
                        proven winning strategy today.
                    </p>

                    {/* Action Button */}
                    <a
                        href="https://wa.me/918709364253"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center justify-center px-8 py-4 bg-neutral-900 text-white font-black rounded-xl shadow-lg hover:bg-red-700 transition-colors duration-300 group"
                    >
                        <MessageCircle
                            size={20}
                            className="mr-3 opacity-90 text-yellow-400"
                        />
                        <span>Book Free Counselling</span>
                        <ArrowRight
                            size={20}
                            className="ml-3 text-yellow-400 group-hover:translate-x-1.5 transition-transform duration-300"
                        />
                    </a>
                </motion.div>
            </div>
        </section>
    );
};

export default CallToActionBanner;
